import React, { Component, createRef } from "react";
// // Editable
// import { BootstrapTable,TableHeaderColumn } from "react-bootstrap-table";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import validate from "../../common/validation";
import { withTranslation } from "react-i18next";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { categoriTypes } from "../StaticData.js";
import { Link } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  addGraderStock,
  getUserByRoleId,
  getUserApi,
  updateGraderStock,
  updateDataEntryStock,
} from "../../api";
import ShowDiffenence from "components/Common/ShowDiffenence";

class EditverifyAndAccept extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      editRowIndex: -1,
      props: props?.location?.query
        ? props.location.query
        : {
            isEdit: 1,
            data: null,
          },
      graderList: [],
      notEditableRows:
        props.location.query.isEdit == 1
          ? props?.location?.query?.data?.stockDataEntryInWards.map(x => x.id)
          : props?.location?.query?.data?.stockDataEntryInWards.map(x => x.id),
      stockList:
        props.location.query.isEdit == 1
          ? props?.location?.query?.data?.stockDataEntryInWards
          : props?.location?.query?.data?.stockDataEntryInWards,
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async componentDidMount() {
    const grader = await getUserApi({
      factoryId: this.state.props.data.jangad.factory.id,
      roleId: "ROLE0000002",
    });
    if (grader && grader.data) {
      this.setState({
        graderList: grader.data.users,
      });
    }
  }

  deleteRow(rowIndex) {
    this.state.stockList.splice(rowIndex, 1);
    this.setState({
      stockList: this.state.stockList,
      notEditableRows: this.state.stockList.map((x, index) => x.id),
    });
  }
  addRow() {
    this.setState({
      stockList: [
        ...this.state.stockList,
        {
          id: this.state.stockList.length + 1,
          srNo: this.state.stockList.length + 1,
          categoryId: 1,
          weight: 0,
          weightType: "CT",
          pieces: 0,
          remarks: "",
          nextRemarks: "",
        },
      ],
      notEditableRows: [
        ...this.state.notEditableRows,
        this.state.stockList.length + 1,
      ],
    });
  }
  handleSubmit = async values => {
    if (this.state.stockList.filter(x => x.weight > 0 && x.pieces > 0).length) {
      if (this.state.props.isEdit == 1) {
        let temp = {
          mainJangadId: this.state.props.data.mainJangadId,
          jangadId: this.state.props.data.jangadId,
          dataEntryStockId: this.state.props.data.id,
          remarks: this.state.props.data.nextRemarks,
          stockGraderInWards: this.state.props.data.stockDataEntryInWards.map(
            (x, index) => {
              return {
                id: index + 1,
                stockDataEntryInWardId: x.id,
                remarks: x.nextRemarks,
                nextRemarks: "",
                weight: x.weight,
                shapeId: x.shapeId,
                weightType: x.weightType,
                pieces: x.pieces,
                mainJangadId: this.state.props.data.mainJangadId,
                jangadId: this.state.props.data.jangadId,
                dataEntryStockId: this.state.props.data.id,
              };
            }
          ),
        };
        const data = await addGraderStock(temp);
        this.state.history.goBack();
      }
    }
  };

  async reject() {
    const data = await updateDataEntryStock({
      id: this.state.props.data.id,
      graderStatus: "R",
    });
    this.state.history.goBack();
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    const defaultSorted = [
      {
        dataField: "srNo",
        order: "asc",
      },
    ];
    document.title = "data entry person";
    //meta title
    this.columns1 = [
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: "",
        sort: true,
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "pieces", newValue, row, column),
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "weight", newValue, row, column),
      },

      {
        dataField: "shapeId",
        text: `${this.props.t("Shapes")}`,
        type: "text",
        footer: "",
        formatter: (cell, row) => {
          return row.shape.name;
        },
      },
      {
        dataField: "remarks",
        text: `${this.props.t("Self Internal Remarks")}`,
        footer: "",
      },
      {
        dataField: "nextRemarks",
        text: `${this.props.t("For Next Person Instruction")}`,
        footer: "",
      },
      {
        dataField: "edit",
        text: `${this.props.t("Edit Data")}`,
        footer: "",
        editable: true,

        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          return (
            <div className="btn-group">
              {!this.state.notEditableRows.includes(row.id) ? (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setState({
                      notEditableRows: [...this.state.notEditableRows, row.id],
                    });
                  }}
                >
                  <img src="images/dashboard-images/print.svg"></img>
                </span>
              ) : (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    if (
                      this.state.notEditableRows.length ===
                      this.state.stockList.length
                    )
                      this.setState({
                        notEditableRows: this.state.notEditableRows.filter(
                          x => x != row.id
                        ),
                      });
                  }}
                >
                  <img src="images/dashboard-images/edit.svg"></img>
                </span>
              )}
              <button
                className="bg-transparent border-0 ms-3"
                onClick={() => this.deleteRow(rowIndex)}
              >
                <img src="images/dashboard-images/deleteRow.svg"></img>
              </button>
            </div>
          );
        },
        formatter: (cell, row, rowIndex) => (
          <div className="btn-group">
            {!this.state.notEditableRows.includes(row.id) ? (
              <span
                className="border-0 rounded ms-2"
                onClick={() => {
                  this.setState({
                    notEditableRows: [...this.state.notEditableRows, row.id],
                  });
                }}
              >
                <img src="images/dashboard-images/print.svg"></img>
              </span>
            ) : (
              <span
                className="border-0 rounded ms-2"
                onClick={() => {
                  if (
                    this.state.notEditableRows.length ===
                    this.state.stockList.length
                  )
                    this.setState({
                      notEditableRows: this.state.notEditableRows.filter(
                        x => x != row.id
                      ),
                    });
                }}
              >
                <img src="images/dashboard-images/edit.svg"></img>
              </span>
            )}
            <button
              className="bg-transparent border-0 ms-3"
              onClick={() => this.deleteRow(rowIndex)}
            >
              <img src="images/dashboard-images/deleteRow.svg"></img>
            </button>
          </div>
        ),
      },
    ];

    document.title = "data-entry flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={`${this.props.t("")}`} />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={
                  this.state.props.isEdit == 1
                    ? {
                        id: this.state.props.data.mainJangadId,
                        name: this.state.props.data.mainJangad.name,
                        // partyName: this.state.props.data.mainJangad.party.name,
                        unitName: this.state.props.data.jangad.factoryId,
                        weight: this.state.props.data.jangad.weight,
                        category:
                          this.state.props.data.mainJangad.category.name,
                        pieces: this.state.props.data.jangad.pieces,
                        graderUserId:
                          this.state.props.data.dataEntryGraderUser.name,
                        remarks: this.state.props.data.nextRemarks,
                      }
                    : {
                        id: this.state.props.data.mainJangadId,
                        name: this.state.props.data.mainJangad.name,
                        // partyName: this.state.props.data.mainJangad.party.name,
                        unitName: this.state.props.data.jangad.factoryId,
                        weight: this.state.props.data.jangad.weight,
                        category:
                          this.state.props.data.mainJangad.category.name,
                        pieces: this.state.props.data.jangad.pieces,
                        graderUserId: this.state.props.data.graderUserId,
                        remarks: this.state.props.data.remarks,
                      }
                }
                validationSchema={Yup.object().shape({
                  id: Yup.string().required("This value is required"),
                  // partyName: Yup.string().required("This value is required"),
                  unitName: Yup.string().required("This value is required"),
                  weight: Yup.string().required("This value is required"),
                  pieces: Yup.string().required("This value is required"),
                  graderUserId: Yup.string().required("This value is required"),
                  remarks: Yup.string().max(512).nullable().notRequired(),
                })}
                onSubmit={values => {}}
              >
                {({
                  errors,
                  status,
                  touched,
                  values,
                  submitCount,
                  validateForm,
                }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            {this.state.props.isEdit == 1 && (
                              <h4 className="text-black fw-bold mb-4">
                                {this.props.t("Add New Stock (Inward)")}
                              </h4>
                            )}
                            {this.state.props.isEdit == 2 && (
                              <h4 className="text-black fw-bold mb-4">
                                {this.props.t("Edit Stock (Inward)")}
                              </h4>
                            )}
                            {this.state.props.isEdit == 3 && (
                              <h4 className="text-black fw-bold mb-4">
                                View Stock (Inward)
                              </h4>
                            )}
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>
                        <div className="col-xl-8 col-12">
                          <CardBody>
                            <Row>
                              {/* <div className="mb-3 row">
                                <Label
                                  htmlFor="id"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Jangad Id")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.id && touched.id
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="id"
                                    placeholder="JANGAD0000123"
                                  />
                                  <ErrorMessage
                                    name="id"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div> */}
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="name"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Jangad Id")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.name && touched.name
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="name"
                                    placeholder="JANGAD0000123"
                                  />
                                  <ErrorMessage
                                    name="name"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              {/* <div className="mb-3 row">
                                <Label
                                  htmlFor="partyName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Party Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.partyName && touched.partyName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="partyName"
                                    placeholder="XYZ Diamond"
                                  />
                                  <ErrorMessage
                                    name="partyName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div> */}
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="unitName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Unit Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.unitName && touched.unitName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="unitName"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="unitName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="category"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Diamond Category")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.category && touched.category
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="category"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="category"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="pieces"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Total No of Pieces")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.pieces && touched.pieces
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    value={(() => {
                                      return ShowDiffenence(
                                        this.state.props.data
                                          ?.stockDataEntryInWards,
                                        this.state.props.data.jangad,
                                        "pieces"
                                      );
                                    })()}
                                    type="text"
                                    onWheel={e => e.target.blur()}
                                    name="pieces"
                                    placeholder="2001"
                                  />
                                  <ErrorMessage
                                    name="pieces"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="weight"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Total Weight")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.weight && touched.weight
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    onWheel={e => e.target.blur()}
                                    name="weight"
                                    value={(() => {
                                      return ShowDiffenence(
                                        this.state.props.data
                                          ?.stockDataEntryInWards,
                                        this.state.props.data.jangad,
                                        "weight"
                                      );
                                    })()}
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="weight"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <Label
                                  htmlFor="graderUserId"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Grader Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.graderUserId &&
                                      touched.graderUserId
                                        ? " is-invalid"
                                        : "")
                                    }
                                    readOnly={true}
                                    name="graderUserId"
                                    type="text"
                                  ></Field>
                                  <ErrorMessage
                                    name="graderUserId"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </Row>
                          </CardBody>
                        </div>
                      </div>
                      <div className="row px-3 pt-4">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                            {this.props.t("Stock summary")}
                          </h3>
                        </div>

                        <div className="table-responsive">
                          <BootstrapTable
                            classes="foo"
                            keyField="id"
                            defaultSorted={defaultSorted}
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.state.stockList}
                            columns={[...this.columns1].slice(0, -1)}
                          />
                        </div>
                      </div>

                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="stockDataEntryInWards"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            {this.props.t("Self Internal Remarks")}
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.remarks && touched.remarks
                                ? " is-invalid"
                                : "")
                            }
                            readOnly={true}
                            type="text"
                            name="remarks"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="remarks"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>

                      <div className="col-md-12 text-center text-md-end pe-3 py-5">
                        <Button
                          color="white"
                          className="fs-4 border-0 text-primary me-0 me-md-5 fw-bold"
                          type="submit"
                          onClick={() => {
                            console.log(values),
                              this.handleSubmit(event, values);
                          }}
                        >
                          Accept
                        </Button>
                        <Button
                          type="button"
                          onClick={() => this.reject(event, values)}
                          color="primary"
                          className="fs-4 px-5"
                        >
                          Reject
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(EditverifyAndAccept);
